import * as Yup from 'yup';

export const schema = Yup.object().shape({
  employeeHalfDays: Yup.array().of(
    Yup.object().shape({
      label: Yup.string().required('El campo es requerido'),
      value: Yup.string().required('El campo es requerido'),
    })
  ).min(1, 'Debe seleccionar al menos un elemento de la lista'),
});